<template>
  <div
    class="bgPage min-height-for-section w-100 d-flex justify-content-center align-items-center"
  >
    <div class="container-fluid mb-4">
      <div class="row mt-md-5">
        <div class="col-12">
          <div
            class="w-100 d-flex flex-column align-items-center justify-content-center mb-4"
          >
            <div class="icon-logo mb-3">
              <img
                src="../assets/RTMKlik_favicon_curve.png"
                class="w-100 h-100"
                alt=""
              />
            </div>
            <div class="w-100 header-container">
              <h3 class="header-text my-2">
                RTMKLIK AKAUN
              </h3>
              <p class="mb-0 header-desc">
                Sila masukkan maklumat diri anda untuk daftar akaun RTMKLIK
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="w-100 d-flex align-items-center justify-content-center">
            <div class="login-wrapper p-md-4">
              <div class="w-100 mt-4">
                <!-- form -->
                <vue-form :state="formstate" @submit.prevent="onSubmit">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.name)"
                  >
                    <label class="w-100 inputLabelText text-left">Nama</label>
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      required
                      v-model.lazy="model.name"
                      placeholder="Nama"
                    />

                    <field-messages
                      name="name"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Sila masukkan nama anda
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.email)"
                  >
                    <label class="w-100 inputLabelText text-left">E-mel</label>
                    <input
                      type="email"
                      name="email"
                      class="form-control"
                      placeholder="E-mel"
                      required
                      v-model.lazy="model.email"
                    />

                    <field-messages
                      name="email"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Sila masukkan e-mel anda
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.password)"
                  >
                    <label class="w-100 inputLabelText text-left"
                      >Kata Laluan</label
                    >
                    <input
                      type="password"
                      name="password"
                      class="form-control"
                      required
                      v-model.lazy="model.password"
                      placeholder="Kata Laluan"
                    />

                    <field-messages
                      auto-label
                      name="password"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Sila masukkan kata laluan anda
                      </div>
                      <div slot="password" class="error">
                        Kata laluan anda tidak tepat
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.gender)"
                  >
                    <label class="w-100 inputLabelText text-left"
                      >Jantina</label
                    >
                    <select
                      class="form-control"
                      id="genderselection"
                      name="gender"
                      v-model.lazy="model.gender"
                      placeholder="Jantina"
                      required
                    >
                      <option :value="null">Jantina</option>
                      <option
                        v-for="genderType in genderArr.data.data.entries"
                        :key="genderType.id"
                        :value="genderType.id == 848 ? '' : genderType.id"
                        >{{ genderType.value.en_US }}</option
                      >
                    </select>

                    <field-messages
                      name="gender"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Sila pilih jantina anda
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.nationality)"
                  >
                    <label class="w-100 inputLabelText text-left"
                      >Kewarganegaraan</label
                    >
                    <select
                      class="form-control"
                      id="nationalityselection"
                      name="nationality"
                      v-model.lazy="model.nationality"
                      placeholder="Warganegara"
                      required
                    >
                      <option :value="null">Warganegara</option>
                      <option
                        v-for="nationalityType in nationalityArr.data.data
                          .entries"
                        :key="nationalityType.id"
                        :value="
                          nationalityType.id == 851 ? '' : nationalityType.id
                        "
                        >{{ nationalityType.value.en_US }}</option
                      >
                    </select>

                    <field-messages
                      name="nationality"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Sila nyatakan kewarganegaraan anda
                      </div>
                    </field-messages>
                  </validate>

                  <!-- <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.username)"
                  >
                    <input
                      type="text"
                      name="username"
                      class="form-control"
                      required
                      v-model.lazy="model.username"
                      placeholder="Username"
                    />

                    <field-messages
                      name="username"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Sila masukkan username anda
                      </div>
                    </field-messages>
                  </validate> -->

                  <div
                    class="w-100 d-flex justify-content-start flex-column my-3"
                  >
                    <div class="form-check text-left">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="model.termsCheckbox"
                        id="defaultCheck1"
                      />
                      <label
                        class="form-check-label d-flex flex-row align-items-center"
                        for="defaultCheck1"
                      >
                        <span class="w-100 inputLabelText"
                          >Dengan mengklik Daftar, anda telah membaca dan
                          bersetuju menerima
                          <router-link class="" :to="'/dasar-privasi'"
                            >syarat dasar privasi</router-link
                          >
                          kami</span
                        >
                      </label>
                    </div>
                    <!-- <div class="form-check text-left my-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="defaultCheck1"
                        v-model="model.marketingEmailCheckbox"
                      />
                      <label
                        class="form-check-label text-white"
                        for="defaultCheck1"
                      >
                        Ya, saya setuju menerima e-mel pemasaran
                      </label>
                    </div> -->
                  </div>

                  <div class="py-2 text-center">
                    <button class="modal-default-button" type="submit">
                      Daftar
                    </button>
                  </div>
                  <div class="w-100 my-2 error" v-if="errorMsg">
                    {{ errorMsg }}
                  </div>
                  <div class="w-100 my-2 success" v-if="successMsg">
                    Pendaftaran berjaya! Sila
                    <router-link :to="code ? `/login/${code}` : '/login'"
                      >Log masuk</router-link
                    >
                    untuk mengakses akaun anda.
                  </div>
                </vue-form>
                <!-- <div class="w-100 mt-3">
                  <router-link class="" :to="'/login'">
                    <div class="w-100 d-flex flex-row justify-content-center">
                      <span class="ml-2 signup-text">Sudah menjadi ahli ?</span>
                    </div>
                  </router-link>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
import axios from "axios";
export default {
  components: {
    BreadCrumbsHeader,
  },
  data() {
    return {
      formstate: {},
      model: {
        name: "",
        email: "",
        username: "",
        password: "",
        nationality: null,
        gender: null,
        termsCheckbox: false,
        marketingEmailCheckbox: true,
      },
      errorMsg: "",
      successMsg: false,
      genderArr: [],
      nationalityArr: [],
      code: this.$route.params.code,
    };
  },
  methods: {
    fieldClassName(field) {
      if (!field) {
        return "";
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return "has-success";
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return "has-danger";
      }
    },
    async onSubmit(e) {
      e.preventDefault();
      this.model.username = this.model.email;

      if (
        this.model.name &&
        this.model.email &&
        this.model.username &&
        this.model.password &&
        this.model.nationality &&
        this.model.gender
      ) {
        try {
          let res = await axios.post("https://rtm.glueapi.io/v1/user", {
            status: "active",
            name: this.model.name,
            email: this.model.email,
            username: this.model.username,
            password: this.model.password,
            data: {
              gender: this.model.gender,
              nationality: this.model.nationality,
            },
            agreedToTerms: this.model.termsCheckbox,
            agreedToMarketing: this.model.marketingEmailCheckbox,
          });
          this.errorMsg = "";
          let data = res.data;
          this.successMsg = true;
          return data;
        } catch (error) {
          // console.log(error.response); // this is the main part. Use the response property from the error object
          this.errorMsg = error.response.data.ResponseStatus.Message;
          this.successMsg = false;
          return error.response;
        }
      }
    },
  },
  async created() {
    this.genderArr = await axios.get(
      "https://rtm.glueapi.io/v1/content-list/4",
      {
        responseType: "json",
      }
    );
    this.nationalityArr = await axios.get(
      "https://rtm.glueapi.io/v1/content-list/2",
      {
        responseType: "json",
      }
    );
  },
};
</script>

<style scoped>
.min-height-for-section {
  min-height: 80vh;
  padding: 4rem 0;
}
.bgPage {
  background: url("../assets/rtmklik/bg-login-v2.png") no-repeat center center
    fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.icon-logo {
  width: 80px;
  height: 80px;
}

.header-container {
  max-width: 480px;
}
.header-text {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.header-desc {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.login-wrapper {
  width: 100%;
  max-width: 480px;
  border-radius: 12px;
  background: #171f26;
  box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.06),
    0px 4px 8px -2px rgba(16, 24, 40, 0.1);
}
.inputLabelText {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
}
.form-control {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  display: flex;
  padding: 8px 14px;
  align-items: center;
}
.form-control:focus {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.modal-default-button {
  width: 100%;
  display: flex;
  padding: 10px 18px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: #d9e021;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
  outline: none;
}
.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
  padding-top: 4px;
}
.error {
  color: red;
  font-size: 14px;
  margin-top: 4px;
}
.success {
  color: green;
  font-size: 14px;
  margin-top: 4px;
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #ffffff;
  font-size: 14px;
}

input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #ffffff;
  font-size: 14px;
}
@media screen and (max-width: 768px) {
  .pt-livetv {
    padding: 8px 0 0;
  }
  .breadCrumbsWrapper {
    padding: 14px;
  }
  .bgPage {
    background: #000;
  }
}
</style>
